type Props = {
  /** true = η πλαϊνή στήλη είναι ορατή */
  expanded: boolean
  onToggle: () => void
  className?: string
}

export function SidebarToggleButton({ expanded, onToggle, className = '' }: Props) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-zinc-200/80 bg-white text-zinc-700 shadow-sm transition hover:bg-zinc-50 hover:text-zinc-900 dark:border-zinc-700/80 dark:bg-zinc-900 dark:text-zinc-200 dark:hover:bg-zinc-800 dark:hover:text-white ${className}`}
      aria-expanded={expanded}
      aria-label={expanded ? 'Απόκρυψη πλαϊνού μενού' : 'Εμφάνιση πλαϊνού μενού'}
      title={expanded ? 'Κλείσιμο μενού' : 'Άνοιγμα μενού'}
    >
      <svg
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        {expanded ? (
          <>
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M9 3v18" />
            <path d="M14 9l3 3-3 3" />
          </>
        ) : (
          <>
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M9 3v18" />
            <path d="M11 9l-3 3 3 3" />
          </>
        )}
      </svg>
    </button>
  )
}
